export enum AppPropKeys {
  mobileAppNotice = "mobile_app_notice",
  traceEnabled = "trace_enabled",
  specialPromo = "special_promo",
  orgSizeLimit = "org_size_limit",
  prosperStackConvertEnabled = "prosper_stack_convert_enabled",
  activePromotion = "active_promotion",
  defaultShareVideoId = "default_share_video_id",
  onboardingVideoLandscape = "onboarding_video_landscape",
  onboardingVideoPortrait = "onboarding_video_portrait",
}

export interface AppProps {
  mobileAppNotice?: boolean;
  traceEnabled?: boolean;
  orgSizeLimit?: string;
  specialPromo?: string;
  prosperStackConvertEnabled?: boolean;
  activePromotion?: boolean;
  // Default video ID for share links when no specific routine is provided
  defaultShareVideoId?: string;
  // Default onboarding videos (IDs) for different orientations
  onboardingVideoLandscape?: string;
  onboardingVideoPortrait?: string;
}
